// extracted by mini-css-extract-plugin
export default {"wrapper":"basicKyc_wrapper__i411a","title":"basicKyc_title__9pobn"};